<template>
  <div id="app">
    <myheader></myheader>
    <router-view/>
    <myfooter></myfooter>
  </div>
</template>

<script>
import 'siimple'
import 'luminous-lightbox'
import myheader from '@/components/common/Header'
import myfooter from '@/components/common/Footer'

export default {
  components: {
    myheader,
    myfooter
  },
  metaInfo: {
    title: 'Cattery  にゃんこと', // set a title
    htmlAttrs: {
      lang: 'en',
      amp: undefined // "amp" has no value
    }
  }
}
</script>

<style>
#app {
  font-family: 'Yu Gothic', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue